export const GET_MOVIES = Symbol();
export const GET_GENRE = Symbol();
export const GET_MOVIES_BY_GENRE_ID = Symbol();
export const SEARCH_MOVIE = Symbol();
export const GET_POPULAR_MOVIES = Symbol();
export const GET_MOVIE_DETAIL = Symbol();
export const GET_MOVIE_REVIEWS = Symbol();
